import React from 'react'

import { formatMoney } from 'helpers/helpers'

// Общие куски складских сетевых отчётов: остатки, приход, расход товаров.

// Тип позиции склада — dual-поле COALESCE(product_type_id, in_product) на бэке
export const STOCK_PRODUCT_TYPES = [
	{ id: 0, key: 'chain_type_raw' },
	{ id: 1, key: 'chain_type_goods' },
	{ id: 2, key: 'chain_type_prep' },
	{ id: 3, key: 'chain_type_modifier' },
]

export function productTypeOptions(t) {
	return STOCK_PRODUCT_TYPES.map(type => ({ id: type.id, name: t(type.key) }))
}

export function productTypeLabel(t, id) {
	const type = STOCK_PRODUCT_TYPES.find(item => item.id === Number(id))
	return type ? t(type.key) : ''
}

/** Количество: до трёх знаков после запятой, без хвостовых нулей. */
export function qty(value) {
	if (value === null || value === undefined || value === '' || isNaN(value)) return '—'
	const number = Math.round(Number(value) * 1000) / 1000
	if (Number.isInteger(number)) return formatMoney(number)
	return formatMoney(number, 3).replace(/\.?0+$/, '').replace('.', ',')
}

/** Количество с единицей измерения: «12,5 кг». */
export function qtyUnit(value, unit) {
	return unit ? `${qty(value)} ${unit}` : qty(value)
}

/** Отклонение от средней сети в процентах со знаком: «+12,5%». */
export function signedPercent(value) {
	if (value === null || value === undefined || isNaN(value)) return '—'
	const number = Number(value)
	const text = `${Math.abs(number).toFixed(1).replace('.', ',')}%`
	if (Math.abs(number) < 0.05) return '0%'
	return number > 0 ? `+${text}` : `−${text}`
}

/** Ячейка «товар»: название, ниже единица, категория и тип. */
export function ProductNameCell({ row, t, onClick, title, children }) {
	const meta = [row.unit_name, row.category_name, productTypeLabel(t, row.product_type_id)].filter(Boolean).join(' · ')
	return (
		<td className={`chain-name chain-sticky-2 ${onClick ? 'chain-click' : ''}`} onClick={onClick} title={title}>
			<span>{row.product_name}</span>
			{children}
			{meta && <div className="chain-muted">{meta}</div>}
		</td>
	)
}

// Дополнительные итоговые строки под таблицей. Липким остаётся только главный итог (tfoot):
// несколько строк tfoot с bottom: 0 ложатся друг на друга
export const FOOT_EXTRA_STYLE = { fontWeight: 700, background: 'var(--m-surface-2, #f8f9fa)' }

/**
 * Шкала строки для сравнения цен и норм филиалов: разница в пару процентов не должна
 * красить ячейки в полный красный/зелёный. Полуразмах шкалы — не меньше minHalf от середины.
 */
export function relativeStats(stats, minHalf = 0.1) {
	const middle = (stats.min + stats.max) / 2
	const half = Math.max((stats.max - stats.min) / 2, Math.abs(middle) * minHalf)
	return { min: middle - half, max: middle + half }
}
